<template>
  <b-row v-if="$route.meta.breadcrumb || pageTitle" class="content-header mx-0 px-0">

    <!-- Content Left -->
    <b-col class="content-header-left mb-1  " cols="12">
      <b-row class="breadcrumbs-top ">
        <b-col cols="12">
          <h2 class="content-header-title float-left  mb-0 lh-1">
            {{ pageTitle }}
          </h2>
          <strong class="lh-sm ">
            {{ pageSubtitle }}
          </strong>
          <div class="breadcrumb-wrapper" v-if="$route.meta.breadcrumb">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <font-awesome-icon icon="fas fa-home" size="lg"/>
              </b-breadcrumb-item>
         

              <b-breadcrumb-item v-for="(item,i) in breadcrumbs" :key="i" v-bind="item" >
                  {{ item.text }}
              </b-breadcrumb-item>

            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>


  </b-row>
</template>

<script setup>
import { useUtils as useI18nUtils } from '@composables/i18n'



const breadcrumbs = ref([])
const route = useRoute();

const pageTitle = computed(() => {
  if (typeof route.meta.pageTitle === "function") {
    return route.meta.pageTitle();
  } else {
    return route.meta.pageTitle
  }
})  

const pageSubtitle = computed(() => {
  if (typeof route.meta.pageSubtitle === "function") {
    return route.meta.pageSubtitle();
  } else {
    return route.meta.pageSubtitle || ''
  }
})

const cargarBreadcrumbs = () => {
  breadcrumbs.value = [];
  
  if (route.meta.breadcrumb) {
    route.meta.breadcrumb.forEach(b => {
      let breack = {};

      Object.keys(b).forEach(k => {
        if(typeof b[k] === 'function'){
          breack[k] = b[k](route);
        }
      });
      breadcrumbs.value.push({
        ...b,
        ...breack
      });

      // if (b.text && typeof b.text == 'function') {
      //   breack = b.text(route);
      //   // breadcrumbs.value.push({
      //   //   ...b,
      //   //   text: b.text(route)
      //   // })
      // }

      // if(b.to && typeof b.to == 'function'){
      //   breack.to = b.to(route);
      // }


      // else if(b.to && typeof b.to == 'function') {
      //   console.log('To es una function')
      //   let ruta = b.to(route);
      //   console.log(ruta);
      //   breadcrumbs.value.push({
      //     ...b,
      //     to: b.to(route)
      //   })
      // }else{
      //   // console.log(b);
      //   breadcrumbs.value.push(b)
      // }
    })
  }


}

cargarBreadcrumbs();

watch([pageTitle,() => route.name], () => cargarBreadcrumbs());
</script>
